import {HttpClient} from '@angular/common/http';
import {LocatorService} from '../../locator.service';
import {Context} from '../../context/context';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ReceivedMessage} from './received-message';

export class MessagesLoader {
    private httpClient: HttpClient;

    constructor(private messagesType: string) {
        this.httpClient = LocatorService.injector.get(HttpClient);
    }

    public loadMessages(context: Context): Observable<Array<ReceivedMessage>> {
        return this.httpClient.get<Array<ReceivedMessage>>('api/sessions/' + context.currentSessionId + '/messages/' + this.messagesType)
            .pipe(map(messages => messages.reverse()));
    }
}
